import { render, staticRenderFns } from "./SlingshotBets.vue?vue&type=template&id=743c9b5c&scoped=true"
import script from "./SlingshotBets.vue?vue&type=script&lang=js"
export * from "./SlingshotBets.vue?vue&type=script&lang=js"
import style0 from "./SlingshotBets.vue?vue&type=style&index=0&id=743c9b5c&prod&lang=scss"
import style1 from "./SlingshotBets.vue?vue&type=style&index=1&id=743c9b5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743c9b5c",
  null
  
)

export default component.exports